import React from 'react';
import { Input, Checkbox, Button, Overlay, Text } from '@moda/om';
import { noop } from '../../lib/noop';
import { useAuth } from '../../hooks/useAuth';
import { useForm } from '../../hooks/useForm';
import { AuthAction, AuthPayload } from '../../lib/authenticate';
import { LoadingBalls } from '../LoadingBalls';

type GuestProps = {
  className: string;
  onAuth: (authUser?: AuthPayload) => void;
};

type GuestFormValues = {
  email: string;
  emailList: boolean;
};

const validations = {
  email: {
    email: {
      message: 'Invalid email address.',
      value: true
    },
    required: {
      message: 'Please enter an email address.',
      value: true
    }
  }
};

export const Guest: React.FC<GuestProps> = ({ className, onAuth }) => {
  const { error: errorAuth, handleAuth, loading } = useAuth(AuthAction.Register);

  const onSubmit = (values: GuestFormValues) => {
    handleAuth({
      guest: true,
      email: values.email,
      remember: true,
      opted_in: values.emailList
    })
      .then(onAuth)
      .catch(noop);
  };
  const { errors: fieldErrors, handleSubmit } = useForm({ onSubmit, validations });

  return (
    <>
      <form className={className} onSubmit={handleSubmit}>
        <div className="Authentication__title">Guest</div>
        <div className="Authentication__error">{errorAuth}</div>
        <div className="Authentication__fields">
          <Input
            className="Authentication__input"
            error={fieldErrors.email?.message || !!errorAuth}
            name="email"
            data-testid="guestEmail"
            placeholder="Email"
            type="email"
          />
          <Checkbox
            className="Authentication__checkbox"
            defaultChecked
            name="emailList"
            data-testid="guestEmailList"
            type="checkbox"
          >
            Sign me up for special access and updates
          </Checkbox>
        </div>
        <Button className="Authentication__button" type="submit" data-testid="guestSubmit">
          Continue as Guest
        </Button>
      </form>
      <Overlay className="Authentication__overlay" show={loading}>
        <LoadingBalls />
        <Text treatment="eyebrow">Loading</Text>
      </Overlay>
    </>
  );
};
